<template>
  <div class="Map">
    <div class="main">
      <div id="baiduMap"></div>
      <div class="form">
        <input v-model="name" class="name" type="text" placeholder="姓名"/>
        <input v-model="tel" class="tel" type="number" placeholder="手机"/>
        <input v-model="email" class="email" type="text" placeholder="邮箱"/>
        <input v-model="problem" class="problem" type="text" placeholder="问题描述"/>
        <textarea v-model="contents" placeholder="请在此处写下详情的问题描述"></textarea>
        <button class="submit" @click="submit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
  import swal from 'sweetalert2'

  export default {
    name: 'Map',
    mounted() {
      this.initBaiduMap()
    },
    data() {
      return {
        CityInfo: {
          longitude: 120.562891,
          latitude: 31.352447
        },
        name: "",
        tel: "",
        email: "",
        problem: "",
        contents: ""
      }
    },
    methods: {
      initBaiduMap() {
        let that = this
        let script = document.createElement("script")
        script.src = "http://api.map.baidu.com/api?v=2.0&ak=zishHhU993mnCRDS3zncmazHuZkIRfti&callback=createMap"
        document.head.appendChild(script)
        window.createMap = () => {
          //创建Map实例
          var map = new BMap.Map("baiduMap"); // 创建Map实例
          map.centerAndZoom(new BMap.Point(this.CityInfo.longitude, this.CityInfo.latitude), 17);
          map.addControl(new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT
          }));

          var point = new BMap.Point(this.CityInfo.longitude, this.CityInfo.latitude);
          var marker = new BMap.Marker(point);        // 创建标注
          map.addOverlay(marker);                     // 将标注添加到地图中

        }
      },
      submit() {
        if (this.name == "") {
          this.$swal({text: '姓名不能为空!',showCancelButton: false, type: "error"})
          return false
        }
        if (this.tel == "") {
          this.$swal({text: '手机号不能为空!',showCancelButton: false, type: "error"})
          return false
        }
        if (this.tel.length != 11) {
          this.$swal({text: '手机号必须11位!',showCancelButton: false, type: "error"})
          return false
        }
        if (this.email == "") {
          this.$swal({text: '邮箱不能为空!',showCancelButton: false, type: "error"})
          return false
        }
        if (this.problem == "") {
          this.$swal({text: '问题描述不能为空!',showCancelButton: false, type: "error"})
          return false
        }

        this.$swal({text: '提交成功!', type: "success",showCancelButton: false}).then((res) => {
            this.name = ""
            this.tel = ""
            this.email = ""
            this.problem = ""
            this.contents = ""
        })

      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .Map {
    background: rgba(245, 245, 245, 1);
    height: 605px;

    .main {
      width: 1200px;
      margin: 0 auto;

      #baiduMap {
        width: 460px;
        height: 396px;
        display: inline-block;
        margin-top: 68px;
        margin-left: 55px;
      }

      .form {
        width: 600px;
        display: inline-block;
        vertical-align: top;
        margin-top: 68px;
        margin-left: 60px;

        input {
          height: 44px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(204, 204, 204, 1);
          border-radius: 4px;
          margin-bottom: 20px;
          line-height: 44px;
          padding-left: 19px;
          box-sizing: border-box;
          outline: none;

          &.name {
            width: 160px;
            margin-right: 20px;
          }
          &.tel {
            margin-right: 20px;
          }
          &.tel, &.problem {
            width: 200px;
          }
          &.problem {
            width: 600px;
          }
        }
        textarea {
          width: 600px;
          height: 220px;
          border-radius: 4px;
          border: 1px solid rgba(204, 204, 204, 1);
          padding: 20px 19px;
          box-sizing: border-box;
          outline: none;
        }

        .submit {
          width: 120px;
          height: 48px;
          background: rgba(0, 102, 235, 1);
          border-radius: 10px;
          border: none;
          outline: none;
          font-size: 20px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 46px;
          margin-top: 36px;
          cursor: pointer;

          &:hover {
            width: 130px;
            height: 52px;
            margin-top: 34px;
            margin-left: -5px;
            font-size: 23px;

            -webkit-box-shadow: #666 0px 0px 25px;
            -moz-box-shadow: #666 0px 0px 25px;
            box-shadow: #666 0px 0px 25px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact_Us/Map.vue